"use client";

import type { FitnessScoreCardProps } from "./types";
import { FitnessRadarChart } from "@/src/components/fitness/RadarChart/FitnessRadarChart";
import { FitnessScoreCardStats } from "./FitnessScoreCardStats";
import { FitnessScoreDimensionRow } from "./FitnessScoreDimensionRow";
import { cn } from "utils";

export type { FitnessScoreCardProps } from "./types";

/**
 * FitnessScoreCard — Sharpen Generate 分数结果卡（JsonRender）
 *
 * Figma: `97283:75357` Improved · `97921:197450` Declined · `97921:197529` No change
 */
export function FitnessScoreCard({
  total,
  delta,
  dimensions,
  className,
}: FitnessScoreCardProps) {
  return (
    <section
      className={cn(
        "flex w-full flex-col gap-4 overflow-clip rounded-3 border border-border_inverse_transparent10 bg-background_solid_neutral_primary p-4 md:max-w-[534px]",
        className,
      )}
      data-testid="fitness-score-card"
      data-node-id="97283:75357"
    >
      <div className="flex w-full items-start gap-4">
        <FitnessRadarChart
          total={total}
          control={dimensions.control.score}
          safety={dimensions.safety.score}
          growth={dimensions.growth.score}
          size="compact"
          animate={false}
          className="size-[130px] shrink-0"
        />

        <div className="flex min-w-0 flex-1 flex-col gap-3 overflow-clip">
          <FitnessScoreCardStats total={total} delta={delta} />

          <div className="flex w-full flex-col gap-1">
            <FitnessScoreDimensionRow
              label="control"
              score={dimensions.control.score}
              delta={dimensions.control.delta}
            />
            <FitnessScoreDimensionRow
              label="safety"
              score={dimensions.safety.score}
              delta={dimensions.safety.delta}
            />
            <FitnessScoreDimensionRow
              label="growth"
              score={dimensions.growth.score}
              delta={dimensions.growth.delta}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
